<!--名校长工作室概况-->
<template>
    <div class="studio-container">
        <!--第一部分：新闻资讯、轮播、关注度排行-->
        <div class="studio-top">
            <div class="studio-news-list">
                <div class="title-box">
                    <div class="title-name title-active">新闻咨询</div>
                    <div class="title-more" v-if="newsList&&newsList.length>0">更多>></div>
                </div>
                <div class="achieve-list">
                    <div class="news-one" v-for="item in newsList.slice(0,8)" :key="item" @click="viewDetail(item, 2)">
                        {{item.title}}
                    </div>
                    <data-empty v-if="newsList&&newsList.length===0" title="暂无新闻资讯"/>
                </div>

            </div>
            <div class="studio-news">
                <el-carousel :interval="3000" arrow="always">
                    <el-carousel-item class="carousel-item" v-for="item in newsList" :key="item" @click="viewDetail(item, 2)">
                        <img class="img-100" :src="item.cover" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="studio-care">
                <div class="title-box">
                    <div class="title-name title-active">关注度排行</div>
                </div>
                <div class="studio-care-list">
                    <div class="studio-care-rank" v-for="(item,index)  in studioList.slice(0,8)" :key="item" @click="viewStudio(item)">
                        <div :id="'num' + (index + 1)" class="group-active-index">{{index+1}}</div>
                        <div class="group-active-name">{{item.groupName}}</div>
                        <div class="group-active-care">
                            <span style="color:red;">{{item.careNum}}</span>人关注
                        </div>
                    </div>
                    <data-empty v-if="studioList&&studioList.length===0" title="暂无数据"/>
                </div>

            </div>
        </div>
        <!--第二部分：工作室 动态-->
        <div class="studio-second">
            <div class="second-studio-container">
                <div class="title-box">
                    <div class="title-name title-active">名校长工作室</div>
                    <div class="title-more" v-if="studioList&&studioList.length>0">更多>></div>
                </div>
                <div class="second-studio-box">
                    <div class="studio-one" v-for="item in studioList.slice(0,8)" :key="item" @click="viewStudio(item)">
                        <div class="studio-cover">
                            <img class="studio-cover-img" :src="item.groupAvatar" alt />
                        </div>
                        <div class="studio-name">{{item.groupName}}</div>
                    </div>
                    <data-empty v-if="studioList&&studioList.length===0" title="暂无工作室"/>
                </div>
            </div>

            <div class="second-trends-container">
                <div class="title-box">
                    <div class="title-name title-active">工作室动态</div>
                    <div class="title-more" v-if="articleList&&articleList.length>0">更多>></div>
                </div>
                <div class="achieve-list">
                    <div class="group-article-one" v-for="item in articleList.slice(0,10)" :key="item" @click="viewDetail(item, 1)">
                        <div class="group-article-name">{{item.title}}</div>
                        <div class="group-article-belong">
                            {{item.groupName}}
                        </div>
                    </div>
                    <data-empty v-if="articleList&&articleList.length===0" title="暂无动态"/>
                </div>


            </div>
        </div>

        <!--第二部分：工作室 动态-->
        <div class="studio-third">
            <div class="title-box">
                <div class="title-name title-active">成果展示</div>
                <div class="title-more" v-if="achieveList&&achieveList.length>0">更多>></div>
            </div>
            <div class="achieve-list">
                <div class="achieve-item" v-for="item in achieveList.slice(0,8)" :key="item" @click="viewDetail(item, 1)">
                    <div class="achieve-cover">
                        <img class="img-100" :src="item.cover" alt />
                    </div>
                    <div class="achieve-type-title">
                        <div class="achieve-name">{{item.title}}</div>
                    </div>
                </div>
                <data-empty v-if="achieveList&&achieveList.length===0" title="暂无成果"/>
            </div>

        </div>
    </div>
</template>

<script>
import {studioHeadmasterState } from "@/api/admin/studio";
import { timestampToTime } from "@/utils/date";
import dataEmpty from "@/components/dataEmpty";
export default {
    name: "headmasterStudioState",
    components: {dataEmpty},
    data() {
        return {
            timestampToTime,
            studioState:{},
            studioList: [],// 工作室列表
            articleList: [],// 教师文章
            achieveList:[],//成果
            newsList:[],//新闻资讯
        }
    },
    created() {
        this.selectHeadmasterStudioState();
    },
    methods: {
        selectHeadmasterStudioState() {
            studioHeadmasterState().then(res => {
                this.studioState = res.data.data;
                this.studioList = this.studioState.studioList;
                this.articleList = this.studioState.jswzList;
                this.achieveList = this.studioState.cgzsList;
                this.newsList = this.studioState.newsList;
            })
        },
        viewDetail(row,type){
            if (type === 1) {
                this.$router.push({
                    path: "/studioDetail",
                    query: {
                        infoId: row.infoId,
                        isTeachStudioList: 1
                    }
                });
            } else {
                this.$router.push({
                    path: "/newsDetail",
                    query: {
                        data: JSON.stringify(row),
                        isTeachStudioList: 1
                    }
                });
            }
        },
        viewStudio(item) {
            this.$router.push({
                path: "/studioinfo",
                query: {
                    groupId: item.groupId,
                }
            });
        },
    }
}
</script>

<style scoped>
.studio-container {
    width: calc(100vw - 200px);
    height:calc(100vh - 75px);
    overflow-y:auto;
    padding-left: 10px;
    padding-top: 10px;
    box-sizing: border-box;
    font-size: 16px!important;
}
.studio-top{
    display: flex;
    width: 100%;
    height:260px;
    //background-color: #3b62f8;
}
.studio-news-list{
    width: 27%;
    height: 100%;
    padding-right: 10px;
    box-sizing: border-box;
    background-color: #fff;
}
.news-one{
    width: 98%;
    margin: auto;
    height: 28px;
    border-bottom: 1px dashed #cecece;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #3b62f8;
    font-size: 15px;
    line-height: 28px;
}
.studio-news{
    width: 46%;
    height: 100%;
    margin-left: 10px;
}
/deep/ .studio-news .el-carousel{
    width: 100%;
    height: 100%;
}
.carousel-item{
    width: 100%;
    height: 100%;
    cursor: pointer;
    img{
        width: 100%;
        height: 100%;
    }
}
/deep/ .studio-news .el-carousel .el-carousel-item img{
    width: 100%;
    height: 100%;
}
/*指示器按钮*/
/deep/ .el-carousel__button {
    width: 8px;
    height: 8px;
    border: none;
    border-radius: 50%;
    background-color: grey;
}
.studio-care{
    width: 27%;
    height: 100%;
    background-color: #fff;
    margin-left: 10px;
}
.studio-care-list{
    width: 100%;
    height: 100%;
}
.studio-care-rank{
    display: flex;
    border-bottom: 1px dashed #cecece;
    cursor: pointer;
}
.group-active-index{
    width: 30px;
    line-height: 28px;
    text-align: left;
    font-size: 15px;
    padding-left: 5px;
    box-sizing: border-box;
}
.group-active-name{
    line-height: 28px;
    font-size: 15px;
    width: calc(100% - 120px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333333;
}
.group-active-care{
    width: 80px;
    line-height: 28px;
    text-align: right;
    color: #cecece!important;
    font-size: 15px;
}
#num1,
#num2,
#num3,
#num4,
#num5,
#num6,
#num7,
#num8,
#num9,
#num10 {
    background: none !important;
    font-size: 18px;
    font-weight: bold;
    text-indent: 2px;
}
#num1 {
    color: #ed574a;
}
#num2 {
    color: #f8b551;
}
#num3 {
    color: #32b16c;
}
#num4,
#num5,
#num6,
#num7,
#num8,
#num9,
#num10 {
    color: #86c8ff;
}

.studio-second{
    display: flex;
    width: 100%;
    height:auto;
    margin-top: 20px;
}
.second-studio-container{
    width: 66%;
    height: 100%;
    background-color: #fff;
}
.second-studio-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-bottom: 10px;
}
.studio-one{
    width: 25%;
    height: 140px;
    margin-top: 10px;
    cursor: pointer;
}
.studio-cover{
    width: 100px;
    height: 100px;
    margin: auto;

}
.studio-cover-img{
    width: 100px;
    height: 100px;
    border-radius: 50%;
}
.studio-name{
    width: 120px;
    height: 20px;
    margin: auto;
    color: #333;
    font-size: 15px;
    margin-top: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
}
.second-trends-container{
    width: 34%;
    height: 100%;
    background-color: #fff;
    margin-left: 10px;
    margin-top: 3px;
}
.group-article-one{
    display: flex;
    width: 98%;
    margin: auto;
    height: 34px;
    border-bottom: 1px dashed #cecece;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.group-article-name{
    line-height: 36px;
    font-size: 15px;
    width: calc(100% - 140px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333333;
}
.group-article-name:hover{
    color: #3b62f8;
}
.group-article-belong{
    width: 140px;
    line-height: 34px;
    text-align: right;
    color: #cecece!important;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.studio-third{
    width: 100%;
    height:auto;
    margin-top: 20px;
}
.achieve-list{
    background-color: #FFFFFF;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    //padding-bottom: 10px;
    align-items: center;
}
.achieve-item{
    width: 25%!important;
    height: 220px;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.achieve-cover{
    width: 100%;
    height: 160px;
    img{
        width: 100%;
        height: 100%;
    }
}
.achieve-type-title{
    display: flex;
    height: 30px;
    width: 100%;
    margin-top: 10px;
}
.achieve-type{
    height: 20px;
    width: 40px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    background-color: #3b62f8;
    border-radius: 4px;
    //font-weight: bold;
}
.achieve-name{
    height: 20px;
    width: calc(100% - 40px);
    color: #333;
    font-size: 16px;
    text-align: left;
    line-height: 20px;
    //font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-indent: 5px;
}
/*标题栏*/
.title-box{
    display: flex;
    width: 100%;
    height: 30px;
    border-bottom: 2px solid #3b62f8;
    background-color: #FFFFFF;
}
.title-name{
    width: 100px;
    height: 30px;
    line-height: 30px;
    text-align: left;
    text-indent: 5px;
    font-size: 14px;
    font-weight: bold;
    color: #3b62f8;
    //background-color: #cecece;
    cursor: pointer;
}
.title-active{
    //color: #fff;
    //background: #3b62f8!important;
}
.title-more{
    color: #3b62f8!important;
    font-size: 14px;
    height: 30px;
    line-height: 30px;
    margin-left: auto;
    padding-right: 10px;
    cursor: pointer;
}
.title-more:hover{
    text-decoration: underline;
}
</style>